import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Grid, Card, CardMedia, CardContent, Typography, Select, MenuItem, FormControl, InputLabel, Box } from '@mui/material';

function GameMaps() {
    const [maps, setMaps] = useState([]);
    const [gamemodes, setGamemodes] = useState([]);
    const [selectedGamemode, setSelectedGamemode] = useState('');

    useEffect(() => {
        axios.get('https://overfast-api.tekrop.fr/maps')
            .then((res) => {
                setMaps(res.data);
                // Set the available game modes based on the maps data
                const modes = new Set(res.data.flatMap(map => map.gamemodes));
                setGamemodes([...modes]);
            })
            .catch((error) => {
                console.error('Error fetching maps:', error);
            });
    }, []);

    const handleGamemodeChange = (event) => {
        setSelectedGamemode(event.target.value);
    };

    const filteredMaps = selectedGamemode
        ? maps.filter(map => map.gamemodes.includes(selectedGamemode))
        : maps;

    return (
        <Box sx={{ flexGrow: 1, padding: 2 }}>
            <Box sx={{ display: 'flex', justifyContent: 'center', p: 1, mb: 2 }}>
                <FormControl sx={{ m: 1, minWidth: 240 }} size="small">

                    <Select
                        sx={{
                            backgroundColor: 'white',
                            color: 'black',
                            fontFamily: 'Oswald, sans-serif',
                            letterSpacing: '1.1px',
                            fontSize: '18px',
                            textTransform: 'uppercase',

                        }}
                        labelId="gamemode-select-label"
                        id="gamemode-select"
                        value={selectedGamemode}

                        onChange={handleGamemodeChange}
                        displayEmpty

                    >
                        <MenuItem sx={{
                            color: 'black',
                            fontFamily: 'Oswald, sans-serif',
                            letterSpacing: '1.1px',
                            fontSize: '18px',
                            textTransform: 'uppercase',
                            "&:hover": {
                                backgroundColor: "#43444a", color: "white"
                            }
                        }} value="">
                            Tous les modes
                        </MenuItem>
                        {gamemodes.map((mode, index) => (
                            <MenuItem sx={{
                                color: 'black',
                                fontFamily: 'Oswald, sans-serif',
                                letterSpacing: '1.1px',
                                fontSize: '18px',
                                textTransform: 'uppercase',
                                "&:hover": {
                                    backgroundColor: "#43444a", color: "white"
                                }
                            }} key={index} value={mode}>{mode}</MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </Box>
            <Grid container spacing={2}>
                {filteredMaps.map((map, index) => (
                    <Grid item xs={12} sm={6} md={4} key={index}>
                        <Card sx={{ maxWidth: '100%', backgroundColor: '#e1eaf5', borderRadius: '10px', border: 'solid 2px white', boxShadow: 3 }}>
                            <CardMedia
                                component="img"
                                height="140"
                                image={map.screenshot}
                                alt={map.name}
                            />
                            <CardContent>
                                <Typography sx={{ fontFamily: 'Oswald, sans-serif', letterSpacing: '1.1px', textTransform: 'uppercase' }} gutterBottom variant="h6" component="h3">
                                    {map.name}
                                </Typography>
                                <Typography sx={{ fontFamily: 'Kanit, sans-serif', textTransform: 'uppercase' }} variant="body2" color="text.secondary">
                                    Localisation : {map.location}
                                </Typography>
                                <Typography sx={{ fontFamily: 'Kanit, sans-serif', textTransform: 'uppercase' }} variant="body2" color="text.secondary">
                                    Mode(s) de jeux : {map.gamemodes.join(', ')}
                                </Typography>
                            </CardContent>
                        </Card>
                    </Grid>
                ))}
            </Grid>
        </Box>
    );
}

export default GameMaps;
